import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CategoryModule } from '../../appshared/masters/category/category.module';
import { CategoryService } from '../../appshared/masters/category/category.service';
import { FeedbackService } from '../../appshared/webTools/feedback/feedback.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

    public categoryData: CategoryModule[];
    constructor(public service: FeedbackService, public servCategory: CategoryService, private router: Router, private toastr: ToastrService) { }

    ngOnInit(): void {
        this.getAllCategory();
        this.service.formData.addDate = new Date();
        this.service.formData.email = '';
        this.service.formData.message = '';
        this.service.formData.name = '';
        this.service.formData.notes = '';
        this.service.formData.phoneNo = '';
        this.service.formData.wbFeedbackID = 0;

        this.service.formData.gnCategoryID = 1;
        this.service.formData.status = "Waiting";
  }


    public getAllCategory = () => {
        this.servCategory.getCategory("Enguiry Type")
            .subscribe(res => {
                this.categoryData = res as CategoryModule[];
            })
    }

    onSubmit(form: NgForm) {
        if (this.service.formData.wbFeedbackID == 0)
            this.insertRecord(form);
    }

    insertRecord(form: NgForm) {

        this.service.postService().subscribe(
            res => {
                /* this.serviceData2 = res as CategoryModule;*/

                this.toastr.success('تم إرسال استفساركم بنجاح', '');
                this.router.navigate(['/']);
            },
            err => { console.log(err); }
        );
    }


    onPhoneChange(value: string) {
        const englishValue = this.convertToEnglishDigits(value);

        // allow only digits
        if (/^\d*$/.test(englishValue)) {
            this.service.formData.phoneNo = englishValue;
        } else {
            // if invalid, remove non-digits
            this.service.formData.phoneNo = englishValue.replace(/\D/g, '');
        }
    }


    //onOtherPhoneChange(value: string) {
    //    const englishValue = this.convertToEnglishDigits(value);

        
    //    if (/^\d*$/.test(englishValue)) {
    //        this.mainFormStudent.otherPhone = englishValue;
    //    } else {
            
    //        this.mainFormStudent.otherPhone = englishValue.replace(/\D/g, '');
    //    }
    //}

    convertToEnglishDigits(value: string): string {
        const arabicIndicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
        return value.replace(/[٠-٩]/g, d => arabicIndicDigits.indexOf(d).toString());
    }
}
